import React from 'react';
import './chip.css';

interface Props {
	color?: 'primary' | 'secondary' | 'error' | 'warning' | 'success';
	variant?: 'solid' | 'outlined';
	children: React.ReactNode;
}

// Returns strings like: '1,34,255' so they still need to be formatted inline to end up as "rgb(1,34,255)" or "rgba(1,34,255,0.2)"
function resolveRgbColorValueFromProp(color: string = 'primary'): {
	text: string;
	background: string;
	contrast: string;
	main: string;
} {
	switch (color) {
		case 'error':
			return {
				text: '238,2,2',
				main: '238,2,2',
				background: '238,2,2',
				contrast: '255,255,255',
			};
		case 'warning':
			return {
				text: '221,172,0',
				main: '255,211,0',
				background: '255,211,53',
				contrast: '255,255,255',
			};
		case 'success':
			return {
				text: '95,216,85',
				main: '95,216,85',
				background: '95,216,85',
				contrast: '255,255,255',
			};
		case 'primary':
		default:
			return {
				text: '98,2,238',
				main: '98,2,238',
				background: '98,2,238',
				contrast: '255,255,255',
			};
	}
}

const Chip: React.FC<Props> = ({ color = 'primary', variant, children }) => {
	const resolvedColor = resolveRgbColorValueFromProp(color);

	return (
		<span
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minWidth: '80px',
				height: '18px',
				borderRadius: '9px',
				backgroundColor: `rgba(${resolvedColor.background}, 0.2)`,
			}}
		>
			<p
				style={{
					margin: '0px',
					fontSize: '10px',
					textTransform: 'uppercase',
					color: `rgb(${resolvedColor.text})`,
				}}
			>
				{children}
			</p>
		</span>
	);
};

export default Chip;
